import { Chip, Grid, Stack } from '@mui/material';
import Text from '../../../components/detail/components/Text.component';
import _ from 'lodash';
import moment from 'moment/moment';
import DownlaodComponent from '../../../components/detail/components/Download.component';
import MuiTypography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { green } from '@mui/material/colors';
import dayjs from 'dayjs';
import { FeesType, RegistrationStatus } from './Data.conf';
import Link from '../../../components/detail/components/Link.component';
import YachtInvoicingDetails from '../../../components/mexal/YachtInvoicingDetails.component';

export const CommonDetailConf = {
  id: 'yacht_section',
  type: 'section',
  label: 'Yacht Details',
  xs: 12,
  items: [
    {
      type: 'text',
      label: 'Yacht name',
      key: 'attributes.yacht',
      xs: 12,
    },
    {
      type: 'text',
      label: 'Live Map',
      key: 'attributes.url_web',
      xs: 12,
    },
    {
      type: 'text',
      label: 'Yacht type',
      key: 'attributes.yacht_type',
      xs: 12,
      sm: 6,
      md: 3,
    },

    { type: 'text', label: 'Loa', key: 'attributes.loa', xs: 12, sm: 6, md: 3 },
    {
      type: 'text',
      label: 'Beam',
      key: 'attributes.beam',
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      type: 'text',
      label: 'draft',
      key: 'attributes.draft',
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      type: 'text',
      label: 'Gross Tonn',
      key: 'attributes.gross_tonn',
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      type: 'text',
      label: 'Flag',
      key: 'attributes.id_flag.data.attributes.locality_flag',
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      type: 'text',
      label: 'Registry',
      key: 'attributes.registry_type',
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      type: 'text',
      label: 'Port Of Registry',
      key: 'attributes.port_of_registry',
      xs: 12,
      sm: 6,
      md: 3,
    },

    {
      type: 'text',
      label: 'Note',
      key: 'attributes.note',
      xs: 12,
    },
  ],
};

export const DetailConf = {
  initialState: {
    loading: false,
    error: null,
    data: null,
    meta: null,
  },
  fields: [
    { ...CommonDetailConf },
    {
      id: 'yacht_contacts',
      type: 'section',
      label: 'Contacts',
      xs: 12,
      items: [
        { type: 'text', label: '', key: 'attributes.id_yacht_members', xs: 12 },
      ],
    },
    {
      id: 'invoicing_entity_section',
      type: 'section',
      label: 'Invoicing Details',
      xs: 12,
      items: [{ type: 'text', label: '', key: 'attributes.invoicing', xs: 12 }],
    },
    {
      id: 'terms_of_payment_section',
      type: 'section',
      label: 'Berth payments',
      xs: 12,
      items: [
        {
          type: 'text',
          label: '',
          key: 'attributes.payment_preferences',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Fees Type',
          key: 'attributes.fees_type',
          xs: 12,
          sm: 6,
        },
      ],
    },
    {
      id: 'terms_and_conditions_section',
      type: 'section',
      label: 'Terms and conditions',
      xs: 12,
      items: [
        {
          type: 'boolean',
          label: 'Terms and condition',
          key: 'attributes.terms_and_condition',
          xs: 12,
          sm: 4,
        },
        {
          type: 'boolean',
          label: 'Marketing',
          key: 'attributes.feedback',
          xs: 12,
          sm: 4,
        },
        {
          type: 'boolean',
          label: 'Newsletter',
          key: 'attributes.commercial',
          xs: 12,
          sm: 4,
        },
        {
          type: 'boolean',
          label: 'Privacy policy',
          key: 'attributes.privacy_policy',
          xs: 12,
          sm: 4,
        },
        {
          type: 'boolean',
          label: 'User Profiling',
          key: 'attributes.user_profiling',
          xs: 12,
          sm: 4,
        },
      ],
    },

    {
      id: 'signature',
      type: 'section',
      label: 'Registration',
      xs: 12,
      items: [
        {
          type: 'text',
          label: 'Registration Status',
          key: 'attributes.registration_status',
          xs: 12,
        },
        {
          type: 'text',
          label: 'Client Of Signature',
          key: 'attributes.client_of_signature',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Date',
          key: 'attributes.date_submit_signature',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Nautica know',
          key: 'attributes.id_nautica_known.data.attributes.description',
          xs: 12,
        },
        {
          type: 'text',
          label: 'Nautica know note',
          key: 'attributes.nautica_known_note',
          xs: 12,
        },
      ],
    },
    {
      id: 'documents_section',
      type: 'section',
      label: 'Documents',
      items: [
        {
          type: 'documents',
          label: 'Certificate of registry',
          key: 'attributes.yacht_document.data',
          xs: 12,
        },
      ],
    },
  ],
  formatValue: (key, value) => {
    switch (key) {
      case 'attributes.id_yacht.data':
        return (
          <Text label='Yacht name' value={value?.attributes?.yacht_name} />
        );
      case 'attributes.yacht_document.data':
        return (
          <Grid container spacing={{ xs: 2, sm: 4 }}>
            {value?.map((item) => (
              <Grid item key={item.id} xs={12} sm={6} md={4}>
                <DownlaodComponent
                  value={{
                    subLabel: _.get(
                      item,
                      'attributes.id_document_type.data.attributes.document_type'
                    ),
                    title: _.get(item, 'attributes.file.data.attributes.name'),
                    url: _.get(item, 'attributes.file.data.attributes.url'),
                  }}
                  tag='yachts'
                />
              </Grid>
            ))}
          </Grid>
        );

      case 'attributes.id_yacht_members':
        if (value && value.data) {
          return (
            <Grid container spacing={2}>
              {value.data.map((user) => {
                return (
                  <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    key={user.id}
                    sx={{ boxShadow: 0.5 }}
                  >
                    <Grid item xs={12}>
                      {!!user.attributes.is_delivery_manager_on_board ? (
                        <MuiTypography
                          fontWeight='bold'
                          alignItems='center'
                          display='flex'
                          justifyContent='left'
                        >
                          {`${user.attributes.crew_responsability} -  Delivery manager on board`}
                          <CheckCircleIcon
                            sx={{
                              color: green[500],
                              width: 15,
                              height: 15,
                              margin: 0.5,
                            }}
                          />
                        </MuiTypography>
                      ) : (
                        <Text
                          label=''
                          sx={{ fontWeight: 'bold' }}
                          value={user.attributes.crew_responsability}
                        />
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      <Text
                        label='Name'
                        value={
                          user.attributes.id_users_permissions_user?.data
                            .attributes?.name
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Text
                        label='Surname'
                        value={
                          user.attributes.id_users_permissions_user?.data
                            .attributes?.surname
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Text
                        label='Username'
                        value={
                          <Link
                            label={user?.attributes?.id_users_permissions_user?.data?.attributes?.username}
                            value={`/customers/${user?.id}`}
                          />
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Text
                        label='Email'
                        value={
                          user.attributes.id_users_permissions_user?.data
                            ?.attributes?.email
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Text
                        label='Phone number'
                        value={
                          user.attributes.id_users_permissions_user?.data?.attributes?.phone_number
                            ? user.attributes.id_users_permissions_user.data.attributes.phone_number
                            : '-'
                        }
                      />
                    </Grid>

                    <Grid item xs={12}>
                      {_.lowerCase(user.attributes.crew_responsability) === 'captain' && (
                          <Text
                            label='Birthdate'
                            value={
                              user.attributes.id_users_permissions_user?.data?.attributes?.birthdate
                                ? dayjs(
                                  user.attributes.id_users_permissions_user.data.attributes.birthdate
                                ).format('DD-MM-YYYY')
                                : '-'
                            }
                          />
                        )}
                    </Grid>
                    <Grid item xs={12}>
                      {_.lowerCase(user.attributes.crew_responsability) ===
                        'rotate captain' && (
                          <Text
                            label='Start Date'
                            value={
                              user.attributes.start_date
                                ? dayjs(
                                  user.attributes.start_date
                                ).format('DD-MM-YYYY')
                                : '-'
                            }
                          />
                        )}
                    </Grid>
                    <Grid item xs={12}>
                      {_.lowerCase(user.attributes.crew_responsability) ===
                        'rotate captain' && (
                          <Text
                            label='End Date'
                            value={
                              user.attributes.end_date
                                ? dayjs(
                                  user.attributes.end_date
                                ).format('DD-MM-YYYY')
                                : '-'
                            }
                          />
                        )}
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          );
        }
        break;
      case 'attributes.invoicing':
        return <YachtInvoicingDetails value={value} />;
      case 'attributes.draft':
        return (
          <Text label='Draft' value={_.isEmpty(value) ? `${value} m` : '-'} />
        );

      case 'attributes.loa':
        return (
          <Text label='Loa' value={_.isEmpty(value) ? `${value} m` : '-'} />
        );

      case 'attributes.beam':
        return (
          <Text label='Beam' value={_.isEmpty(value) ? `${value} m` : '-'} />
        );

      case 'attributes.payment_preferences':
        if (value && value.data) {
          const paymentPreferences = value.data.map(
            (payment) => payment.attributes.payment_type
          );
          const paymentPreferencesText = _.join(paymentPreferences, ', ');

          return (
            <Text
              label={'Payment preferences'}
              value={
                !_.isEmpty(paymentPreferences) ? paymentPreferencesText : '-'
              }
            />
          );
        }
        break;
      case 'attributes.date_submit_signature':
        return (
          <Text
            label='Date'
            value={value ? moment(value).format('DD-MM-YYYY') : '-'}
          />
        );

      case 'attributes.fees_type':
        return (
          <Text
            label='Fees Type'
            value={
              _.find(FeesType, function (o) {
                return o.id === value;
              }).value
            }
          />
        );

      case 'attributes.yacht':
        return (
          <Stack direction={'row'} spacing={1} alignItems={'flex-start'}>
            <Text
              label='Yacht Name'
              value={
                <Stack direction={'column'} spacing={0.25}>
                  <MuiTypography variant='body1'>
                    {value?.yacht_name || '-'}
                  </MuiTypography>
                  {value?.provenence && (
                    <MuiTypography variant='caption' color='text.secondary'>
                      {value?.provenence}
                    </MuiTypography>
                  )}
                </Stack>
              }
            />
            <Chip label={`#${value?.id || '-'}`} size='small' />
          </Stack>
        );
      case 'attributes.registration_status':
        const color = _.find(
          RegistrationStatus,
          (item) => item.label.toUpperCase() === value.toUpperCase()
        );
        return (
          <Text
            label={'Registration status'}
            value={
              value ? (
                <Chip
                  label={value}
                  color={color?.color}
                  sx={{
                    color: color?.color ? '#fff' : color?.textHex,
                    backgroundColor: color?.hex,
                    opacity: 0.8,
                    fontWeight: 500,
                  }}
                  size='small'
                />
              ) : (
                '-'
              )
            }
          />
        );
      case 'attributes.url_web':
        return (
          <Text
            label='Live Map'
            value={<Link label='vesselfinder' value={value} />}
          />
        );
      default:
        return null;
    }
  },
};
